import React from 'react';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';

import config from '@/configs/config';
import { DELIVERY_METHOD } from '@/helper';

const useStyles = makeStyles((theme) => ({
  card: {
    padding: 10,
    borderBottom: '1px solid rgb(217, 217, 217)',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
    '&:hover': { backgroundColor: 'rgb(217, 217, 217)' },
  },
  cardMedia: {
    position: 'absolute',
    top: 0,
    width: '100%',
    height: '100%',
  },
  title: { fontWeight: theme.typography.fontWeightBold },
}));

const PurchasedPreOrderCard = ({ data }) => {
  const classes = useStyles();
  const history = useHistory();

  const arrivedDateString = React.useMemo(() => {
    if (!data) return '';
    if (data.preOrderFridgeId === DELIVERY_METHOD.DELIVERY) {
      return `配達日期: ${data?.delivery?.date}`;
    }
    const preOrderArrivedNotificationTime = (
      (data.batches || {})[data?.batch]?.preOrderArrivedNotificationTime
    ) || data?.preOrderArrivedNotificationTime || null;
    if (!preOrderArrivedNotificationTime) return '';
    return `取貨時間: ${moment(preOrderArrivedNotificationTime).format('YYYY-MM-DD HH:mm')}`;
  }, [data]);

  return (
    <Box
      className={classes.card}
      width={1}
      onClick={() => history.push('/pre-orders/checkout/history', {
        checkoutData: [{
          ...data,
          fridgeId: data.preOrderFridgeId,
          amount: data.duplicatedCount,
        }],
      })}
    >
      <Grid container spacing={1}>
        <Grid item>
          <Box position="relative" width={100} height={100}>
            <Box
              width={100}
              pb="100%"
              bgcolor="grey.300"
            />
            <Box
              position="absolute"
              width={1}
              height={1}
              top={0}
              left={0}
            >
              {
                data.coverImage && (
                  <img
                    style={{ objectFit: 'cover' }}
                    width="100%"
                    height="100%"
                    src={`${config.RESOURCE_URI}${data.coverImage}`}
                    alt=""
                  />
                )
              }
            </Box>
          </Box>
        </Grid>
        <Grid item xs>
          <Box my={1}>
            <Grid container alignItems="flex-end">
              <Grid item xs={12}>
                <Box
                  fontSize="h6.fontSize"
                  fontWeight="fontWeightBold"
                >
                  {data.title || '商品'}
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box
                  fontSize="subtitle1.fontSize"
                  fontWeight="fontWeightMedium"
                >
                  {`${data.slogan}(${data.spec || ''})`}
                </Box>
              </Grid>
            </Grid>
            <Grid container justify="space-between">
              <Grid item>
                <Box fontSize="body2.fontSize">
                  {`預購數量: ${data.duplicatedCount || 0}`}
                </Box>
              </Grid>
            </Grid>

            <Grid container justify="space-between">
              <Grid item />
              <Grid item>
                <Box fontSize="body2.fontSize">
                  {arrivedDateString}
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PurchasedPreOrderCard;
